import PT_BR from './pt_br/language';

const LANGUAGE = {
  pt_BR: PT_BR
}

export default LANGUAGE;



// WEBPACK FOOTER //
// ./src/data/language/language.js